export default "__VITE_PUBLIC_ASSET__27df11eb__"